import { mergeWith, isArray, cloneDeep } from 'lodash';

const initialState = {
  nome: '',
  layoutSlug: null,
  layoutCabecalho: [],
  arquivo: {
    id: '',
    fileObj: undefined,
    delimitador: ';',
    involucro: '"',
    escape: '"',
    uploading: false
  }
};

const state = cloneDeep(initialState);

const getters = {};

const actions = {
  setImportadorDados({ commit }, value) {
    commit('SET_IMPORTADOR_DADOS', value);
  },
  clearImportadorDados({ commit }) {
    commit('CLEAR_IMPORTADOR_DADOS');
  }
};

const mutations = {
  SET_IMPORTADOR_DADOS: (state, value) => mergeWith(state, value, (_, src) => (isArray(src) ? src : undefined)),
  CLEAR_IMPORTADOR_DADOS: (state) => Object.assign(state, cloneDeep(initialState))
};

export default {
  state,
  getters,
  actions,
  mutations
};
